import { FiHeadphones, FiSearch } from 'react-icons/fi'
import Styles from './chat.module.scss'
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getConversationList, getFullChat } from '../../store/chat/chatActions';
import { getImage } from '../../utils';
import NotFoundWidget from '../widgets/NotFound';
import Search from './seach-input';

function chatListFileLabel(message) {
    if (!message?.isFile) return null;
    const raw =
        message.file?.originalName ||
        message.file?.originalname ||
        message.file?.name;
    if (typeof raw === 'string' && raw.trim()) return raw.trim();
    return 'File';
}

function chatListPreviewText(message) {
    if (!message) return '';
    if (message.hidden === true) return 'Deleted message';
    if (message.isFile) return chatListFileLabel(message) ?? 'File';
    return message.message ?? '';
}

const Messages = ({ getMessage = false, search = true, defaultChat = null }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { currentChat, chats } = useSelector((state) => state.chat)
    const [searchText, setSearchText] = useState("")
    
    useEffect(() => {
        if (getMessage) {
            dispatch(getConversationList())
        }
    }, [])
    
    useEffect(() => {
        if (defaultChat) {
            handleReadMessage(defaultChat)
        }

    }, [defaultChat])

    const handleReadMessage = (id) => {
        dispatch(getFullChat(id))
    }

    const handleChangeSearchText = (value) => {
        setSearchText(value)
    }

    const MessagesItem = ({ chat }) => {
        const isSelected = (currentChat !== null ? chat._id === currentChat._id : false);
        
        const raw = typeof chat.unreadCount === 'number' ? chat.unreadCount : 0;
        const n = isSelected ? 0 : raw;
        const preview = chatListPreviewText(chat.message);
        const deletedLast = Boolean(chat.message?.hidden);
        return (
                <div
                    onClick={() => {
                        if (getMessage) {
                            navigate(`/chat/${chat._id}`);
                        } else if (!isSelected) {
                            handleReadMessage(chat._id);
                        }
                    }}
                    className={`relative ${Styles.messageContainer} ${isSelected ? Styles.selected : ''}`}
                >
                    {chat.support === true ? 
                        <span className={`h-[50px] w-[50px] ${isSelected ? 'bg-white' : 'bg-nt-grey-light'} rounded-full flex items-center justify-center text-nt-blue`}>
                        <FiHeadphones size={30} /></span> 
                    : <img className={Styles.avatar+ " rounded-full object-cover"} src={getImage(chat.user?.avatar, "AVATAR")} alt="" />}

                    <div className={Styles.content}>
                        <div className="capitalize">
                            {chat.support === true ? "Support" : (chat.user?.firstName ?? '') + " " + (chat.user?.lastName ?? '')}
                        </div>
                        {chat.message ? <div className={`${Styles.lastMessage} ${deletedLast ? 'italic text-gray-500 line-through' : ''}`} title={chat.message.isFile && !chat.message.hidden ? chatListFileLabel(chat.message) : preview || undefined}>
                            {preview}
                        </div> : ''}
                    </div>
                    {n > 0 ? (
                        <span className={Styles.unreadBadge} aria-label={`${n} unread`}>
                            {n > 99 ? '99+' : n}
                        </span>
                    ) : null}
                </div>
            );
    }

    const chatsList = chats.filter(
        (v) =>
            (!v.user && "Support".includes(searchText) && v.support) ||
            (v.user && (v.user.firstName + " " + v.user.lastName).includes(searchText))

    )

    return (
        <>
            {search && <Search handleChangeSearchText={handleChangeSearchText} searchText={searchText} key={"search-input"}/>}
            <div className={`${Styles.messageList} w-full bg-white rounded-xl`}>
                {
                    chatsList.length > 0 ?
                        (chatsList.map((chat, i) => {
                            return <MessagesItem chat={chat} key={chat._id ?? i} />
                        })) :
                        <NotFoundWidget message="No Chat History" />
                }
                { }
            </div>
        </>
    )
}

export { Messages }